/**
 * Created by seaasun on 2018/2/9.
 */
import _ from 'lodash'
export default {
  options: {
    duration: 5000,
    hasClose: true,
    onlyGroup: false
  },
  id: 1,
  templates: {
    networkError: {
      type: 'error',
      title: 'Error',
      msg: 'Network connect fail'
    }
  },
  notice (type, msg, options) {
    let item = {}
    if (this.templates.hasOwnProperty(type)) {
      item = Object.assign({}, this.templates[type])
    } else {
      item.type = type
    }
    item = Object.assign(item, this.options, options)
    item.msg = msg || item.msg
    item.id = this.id

    if (item.onlyGroup &&
      _.findIndex(this.news, val => { return val.onlyGroup === item.onlyGroup }) > -1) {
      return false
    }

    this.news.push(item)
    this.id += 1
    // set delete
    let id = this.id
    if (item.duration !== 0) {
      setTimeout(() => {
        this.close(id)
      }, item.duration)
    }
    return id
  },
  close (id) {
    this.news.splice(_.findIndex(this.news, item => {
      return item.id === id
    }), 1)
  },
  clear () {
    this.news.splice(0)
  },
  news: []
}



// WEBPACK FOOTER //
// ./src/components/common/notification.js